import authService from './authService';
import { ApiResponse } from '../types/common';

// ─── Types ──────────────────────────────────────────────────────

export interface UserPreference {
  user_email: string;
  preference_entity: string;
  preference_parameters: string;
}

export interface SalesReportPreferences {
  order_status_ids?: number[];
  product_skus?: { sku: string; description: string }[];
  seller_id?: number;
  order_type_ids?: number[];
  /** Empresas emissoras; ausente = todas. */
  company_ids?: number[];
  sales_channel_ids?: number[];
  payment_method_ids?: number[];
  is_payed?: boolean;
  is_first_purchase?: boolean;
}

// ─── Service ────────────────────────────────────────────────────

class UserPreferencesService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  /**
   * Get user preferences for a specific entity
   */
  async getPreferences<T = SalesReportPreferences>(entity: string): Promise<T | null> {
    try {
      const apiClient = await this.getApiClient();
      const response = await apiClient.get(`/user-preferences/${encodeURIComponent(entity)}`);
      if (!response.ok) {
        if (response.status === 404) return null;
        return null;
      }
      const data: ApiResponse<UserPreference> = await response.json();
      if (!data.data?.preference_parameters) return null;
      return JSON.parse(data.data.preference_parameters) as T;
    } catch {
      return null;
    }
  }

  /**
   * Save user preferences for a specific entity
   */
  async savePreferences(entity: string, parameters: Record<string, unknown>): Promise<void> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.put(`/user-preferences/${encodeURIComponent(entity)}`, {
      preference_parameters: JSON.stringify(parameters),
    });
    if (!response.ok) {
      throw new Error('Erro ao salvar preferências do usuário');
    }
  }
}

export const userPreferencesService = new UserPreferencesService();
export default userPreferencesService;
